<template>
  <v-snackbar
    v-model="config.show"
    :bottom="config.y === 'bottom'"
    :color="config.color"
    :left="config.x === 'left'"
    :multi-line="config.mode === 'multi-line'"
    :right="config.x === 'right'"
    :timeout="config.timeout"
    :top="config.y === 'top'"
    :vertical="config.mode === 'vertical'"
    :outlined="config.outlined"
    style="z-index: 999999"
  >
    {{ config.text }}
  </v-snackbar>
</template>

<script>
export default {
  name: 'Message',
  data: () => ({
    config: {},
  }),
  methods: {
    init(config, callback = () => {}) {
      this.config = Object.assign(
        {
          show: true,
          x: '',
          y: 'top',
          color: 'info',
          mode: '',
          timeout: 5000,
          outlined: false,
          text: '',
        },
        config
      )
      setTimeout(callback, this.config.timeout)
    },
  },
}
</script>
